import Locator from "./Locator";

export default Locator